import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxTargetAccumulator } from '@/store/targetAccumulator/state.ts';

export const SavedTargetAccumulatorValidator = arkScope.type({
  'clientId?': 'number',
  properties: {
    'clientsWay?': "'Buy' | 'Sell'",
    'currencyPair?': 'string',
    'cutOffMarketPlace?': 'string',
    'deliveryDate?': 'string | null',
    'expiryDate?': 'string | null',

    'notional?': 'number | null',
    'notionalCurrencyIndex?': 'CurrencyChoice',
    'premiumDate?': 'string | null',
    amountMode: "'Fixing' | 'Total'",
    'leverage?': 'number',
    'leverageAmount?': 'number',

    'accuType?': "'TargetAccu' | 'PIVOTEKI' | 'PIVOT' | 'EKI'",
    'targetProfitType?': 'TargetProfitType',
    'target?': 'number',

    'strike?': 'number',

    'pivot?': 'number',
    'strikeDown?': 'number',
    'strikeUp?': 'number',

    'ekiTrigger?': 'number',

    'ekiDown?': 'number',
    'ekiUp?': 'number',

    'firstFixingDate?': 'string',
    'lastFixingDate?': 'string',
    'marginCurrency?': 'string',
    'numberOfFixings?': 'number',
    'numberOfSettlements?': 'number',
    'markupCurrency?': 'string',
    'fixingFrequency?': 'Frequency',
    'settlementFrequency?': 'Frequency',
    'isCrossed?': 'boolean',
    'crossCurrency?': 'string',
    'maxDate?': 'string',
    'hedgeType?': "'Spot' | 'Live' | 'Forward'",
    'settlementMode?': "'Cash' | 'Physical_Spot' | 'Physical_Forward'",
    'cashSettlementCurrency?': 'string',
  },
  tileId: 'string',
  type: "'TargetAccumulator'",
});

export type SavedTargetAccumulator = typeof SavedTargetAccumulatorValidator.infer;
export const SavedTargetAccumulator = {
  fromTargetAccumulator: (targetAccumulator: FxTargetAccumulator, tileId: string): SavedTargetAccumulator => {
    return {
      clientId: targetAccumulator.clientId,
      properties: {
        clientsWay: targetAccumulator.properties.clientsWay,
        currencyPair: targetAccumulator.properties.currencyPair,
        cutOffMarketPlace: targetAccumulator.properties.cutOffMarketPlace,
        deliveryDate: targetAccumulator.properties.deliveryDate,
        expiryDate: targetAccumulator.properties.expiryDate,
        notional: targetAccumulator.properties.notional,
        notionalCurrencyIndex: targetAccumulator.properties.notionalCurrencyIndex,
        premiumDate: targetAccumulator.properties.premiumDate,
        amountMode: targetAccumulator.properties.amountMode,
        leverage: targetAccumulator.properties.leverage,
        leverageAmount: targetAccumulator.properties.leverageAmount,
        accuType: targetAccumulator.properties.accuType,
        targetProfitType: targetAccumulator.properties.targetProfitType,
        strike: targetAccumulator.properties.strike,
        pivot: targetAccumulator.properties.pivot,
        strikeDown: targetAccumulator.properties.strikeDown,
        strikeUp: targetAccumulator.properties.strikeUp,
        ekiTrigger: targetAccumulator.properties.ekiTrigger,
        ekiDown: targetAccumulator.properties.ekiDown,
        ekiUp: targetAccumulator.properties.ekiUp,
        target: targetAccumulator.properties.target,
        firstFixingDate: targetAccumulator.properties.firstFixingDate,
        lastFixingDate: targetAccumulator.properties.lastFixingDate,
        marginCurrency: targetAccumulator.properties.marginCurrency,
        numberOfFixings: targetAccumulator.properties.numberOfFixings,
        numberOfSettlements: targetAccumulator.properties.numberOfSettlements,
        markupCurrency: targetAccumulator.properties.markupCurrency,
        fixingFrequency: targetAccumulator.properties.fixingFrequency,
        settlementFrequency: targetAccumulator.properties.settlementFrequency,
        isCrossed: targetAccumulator.properties.isCrossed,
        crossCurrency: targetAccumulator.properties.crossCurrency,
        maxDate: targetAccumulator.properties.maxDate,
        hedgeType: targetAccumulator.properties.hedgeType,
        settlementMode: targetAccumulator.properties.settlementMode,
        cashSettlementCurrency: targetAccumulator.properties.cashSettlementCurrency,
      },
      tileId,
      type: 'TargetAccumulator',
    };
  },
} as const;
